var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPsychologistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4485 28.9912C17.152 31.0272 15.0906 32.6359 13.2592 35.8087H9.16864C10.2161 33.7484 10.6288 32.6017 10.4082 30.6026C6.44104 29.5108 5.49507 27.9474 5.82185 23.6611",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80518 21.8021C9.86471 18.4039 13.8919 19.4542 15.6224 22.7498C16.3597 24.1538 16.6991 25.7948 17.7768 26.9581C25.1942 34.9646 37.3799 19.7848 25.5308 15.9762C22.06 14.8606 20.5726 17.5876 22.06 18.8272",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1676 15.7286C21.9129 15.483 20.6969 14.2412 21.4406 12.3818",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1506 21.3062C24.6632 25.1488 18.8373 25.1488 18.8373 20.5625",
    stroke: "#00E500",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1105 23.6611C17.2261 27.7517 10.1606 29.611 10.1606 24.157",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0851 9.03516C20.4486 13.2496 13.5071 15.7287 11.3999 12.6299",
    stroke: "#00E500",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2168 13.7002C13.6137 14.5679 14.251 18.0831 16.4822 18.0831",
    stroke: "#00E500",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9198 12.0095C25.5312 9.28251 31.2332 10.3981 30.2415 14.2407",
    stroke: "#00E500",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3486 17.0918C32.4851 20.2924 36.0673 21.3063 38.5464 18.5793",
    stroke: "#00E500",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6299 26.3881C42.3889 29.7349 44.4961 15.2321 35.8193 11.1416",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3317 15.7285C39.7857 8.91093 28.6298 2.34131 22.6799 8.41511",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.283 6.67964C21.2281 3.73647 14.0031 4.69636 12.7635 9.2827",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4991 6.67999C10.0367 5.8123 4.2108 9.77887 3.96289 15.1089",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1605 14.8611C-2.11103 11.6382 -0.499622 27.3805 5.94606 27.0087",
    stroke: "#0052FD",
    strokeWidth: 1.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychologistIcon);
export default __webpack_public_path__ + "static/media/PsychologistIcon.4dd0d7d8d0e37d6082d5b188d1d90259.svg";
export { ForwardRef as ReactComponent };